import { render, staticRenderFns } from "./OsmStats.vue?vue&type=template&id=28ea333b&scoped=true"
import script from "./OsmStats.vue?vue&type=script&lang=js"
export * from "./OsmStats.vue?vue&type=script&lang=js"
import style0 from "./OsmStats.vue?vue&type=style&index=0&id=28ea333b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea333b",
  null
  
)

export default component.exports